import { IconProps } from '../types';

function DimensionsSolidIcon({ className, id }: IconProps) {
  return (
    <svg
      id={id}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      className={className || 'h-5 w-5'}
    >
      <path
        fillRule="evenodd"
        d="M15,7v9c0,1.1-.9,2-2,2H4c-1.1,0-2-.9-2-2V7c0-1.1.9-2,2-2h9c1.1,0,2,.9,2,2ZM5,3h7v1l2.6-1.5-2.6-1.5v1h-7v-1l-2.6,1.5,2.6,1.5v-1ZM18.01,8h.99l-1.5-2.6-1.5,2.6h1.01v7h-1.01l1.5,2.6,1.5-2.6h-.99v-7Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default DimensionsSolidIcon;
